<template>
    <div>

        <h1 v-text="fullName"></h1>


        <form @submit.prevent="submitForm()" @keydown="form.errors.clear($event.target.name)">

            <fieldset>
                <div class="form__legend">Osobní údaje</div>
                <div class="form__row">
                    <label class="form--required">Jméno</label>
                    <div class="form__controls">
                        <input type="text" name="first_name" v-model="form.first_name">
                        <div class="form__error" v-html="form.errors.get('first_name')"></div>
                    </div>
                </div>
                <div class="form__row">
                    <label class="form--required">Příjmení</label>
                    <div class="form__controls">
                        <input type="text" name="last_name" v-model="form.last_name">
                        <div class="form__error" v-html="form.errors.get('last_name')"></div>
                    </div>
                </div>
                <div v-if="user.login" class="form__row">
                    <label>Login</label>
                    <div class="form__controls">
                        <div class="px-3 py-2" v-text="user.login"></div>
                    </div>
                </div>
                <div class="form__row">
                    <label class="form--required">Email</label>
                    <div class="form__controls">
                        <input type="text" name="email" v-model="form.email">
                        <div class="form__error" v-html="form.errors.get('email')"></div>
                        <div v-if="! form.errors.get('email') && user.login" class="form__help max-w-xl">
                            E-mailovou adresu můžete změnit, bude použita pro případné notifikace.
                            Pro přihlašování budete nadále používat svoje uživatelské jméno a heslo
                            (stejné jako do MS Office, UIS a dalších aplikací).
                        </div>
                    </div>
                </div>
                <div class="form__row">
                    <label>Telefon</label>
                    <div class="form__controls">
                        <input type="text" name="phone" v-model="form.phone">
                        <div class="form__error" v-html="form.errors.get('phone')"></div>
                    </div>
                </div>
                <div v-if="! user.login" class="form__row">
                    <label>Heslo</label>
                    <div class="form__controls">
                        <a class="btn py-1"
                            :href="url(`/users/${user.id}/password`)"
                            v-text="user.hasLocalPassword ? `Změnit heslo` : `Nastavit heslo`"
                        ></a>
                    </div>
                </div>
            </fieldset>

            <div class="md:flex" v-if="authIsSuper()">

                <fieldset class="flex-1">
                    <div class="form__legend">Skupiny (role)</div>
                    <div class="grid gap-2">
                        <label v-for="role in allRoles" :key="role.name" class="reset">
                            <input class="form__checkbox" type="checkbox" :value="role.name" v-model="form.roles">
                            {{ role.title }}
                        </label>
                    </div>
                </fieldset>

                <fieldset class="flex-1 ml-4">
                    <div class="form__legend">Oprávnění</div>
                    <div class="grid gap-2">
                        <label v-for="permission in allPermissions" :key="permission.name" class="reset">
                            <input class="form__checkbox" v-if="isSelectedViaRole(permission.name)" type="checkbox" :checked="true" disabled>
                            <input class="form__checkbox" v-else type="checkbox" :value="permission.name" v-model="form.permissions">
                            {{ permission.title }}
                        </label>
                    </div>
                </fieldset>

            </div>

            <div class="form__buttons">
                <a :href="returnUrl" class="btn">
                    <icon name="x" />
                    Zrušit</a>
                <btn class="btn--primary" type="submit" :loading="sending" :disabled="form.errors.any()">
                    Uložit
                    <icon name="chevron-right" />
                </btn>
            </div>

        </form>

    </div>
</template>

<script>
import Form from './utils/Form.js';
export default {
    props: [
        'user',
        'hasRoles',
        'hasPermissions'
    ],

    data() {
        return {
            loaded: false,
            sending: false,
            returnUrl: '/',
            allRoles: null,
            allPermissions: null,

            form: new Form([
                'first_name',
                'last_name',
                'email',
                'phone',
                'roles',
                'permissions'
            ], this.user)
        }
    },

    computed: {
        /**
         * get an array of permission names granted via roles
         */
        permissionsViaRoles() {
            if (! this.loaded) return [];

            let permissions = [];
            this.form.roles.map(name => {
                permissions = permissions.concat(this.allRoles[name].permissions);
            });
            return permissions;
        },

        fullName() {
            return `${this.form.first_name} ${this.form.last_name}`;
        }
    },

    watch: {
        roles() {
            this.removePermissionsViaRoles();
        }
    },

    methods: {
        loadRoles() {
            return axios.get(url('/roles'))
                .then(result => {
                    this.allRoles = result.data;
                });
        },

        loadPermissions() {
            return axios.get(url('/permissions'))
                .then(result => {
                    this.allPermissions = result.data;
                });
        },

        isSelectedViaRole(permission) {
            return this.permissionsViaRoles.indexOf(permission) !== -1;
        },

        /**
         * remove from checked Permissions those granted via roles
         */
        removePermissionsViaRoles() {
            this.form.permissions = this.form.permissions.filter(permissionName => {
                return this.permissionsViaRoles.indexOf(permissionName) === -1;
            });
        },

        getReturnUrl() {
            if (document.referrer.match(/users$/)) {
                return document.referrer;
            }

            if (document.referrer.match(/users\?/)) {
                return document.referrer;
            }

            return url('/');
        },

        authIsSuper() {
            return window.App.auth.roles.indexOf('super') !== -1;
        },

        removeRolesAndPermissionsIfNotAuthorised() {
            if (! this.authIsSuper()) {
                delete this.form.roles;
                delete this.form.permissions;
            }
        },

        submitForm() {

            this.sending = true;

            this.removeRolesAndPermissionsIfNotAuthorised();

            this.form.patch(url(`/users/${this.user.id}`))

                .then(response => {
                    this.sending = false;
                    Notify.swal({
                        icon: 'success',
                        title: 'Uloženo',
                        timer: 2000
                    }).then(() => {
                        window.location.assign(this.returnUrl);
                    });
                })

                .catch(errors => {
                    this.sending = false;

                    // other than validation error
                    if (errors.status !== 422) {
                        console.log(errors);
                        alert('Chyba při odesílání formuláře');
                    }
                });
        }
    },

    mounted() {
        this.returnUrl = this.getReturnUrl();

        Promise.all([
            this.loadRoles(),
            this.loadPermissions()
        ]).then(() => {
            this.form.roles = this.hasRoles;
            this.form.permissions = this.hasPermissions;
            this.loaded = true;
            this.removePermissionsViaRoles();
        });
    }
}
</script>
